import React, { useState, useEffect } from "react";
import { FaBars } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { animateScroll as scroll } from "react-scroll";
import {
  Nav,
  NavLogo,
  NavbarContainer,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  NavBtn,
  NavBtnLink,
  DropDownContent,
  SubA,
  DropDownLink,
} from "./NavbarStyle";

const Navbar = ({ toggle }) => {
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY > 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo to="/" onClick={toggleHome}>
              <h1>Kartik Jha</h1>
            </NavLogo>
            <MobileIcon onClick={toggle}>
              <FaBars />
            </MobileIcon>
            <NavMenu>
              <NavItem>
                <NavLinks
                  to="about"
                  smooth={true}
                  duration="500"
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  About
                </NavLinks>
              </NavItem>

              <NavItem>
                <NavLinks
                  to="pricing"
                  smooth={true}
                  duration="500"
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Services
                </NavLinks>
              </NavItem>
              <NavItem>
                <DropDownLink
                  to="discover"
                  smooth={true}
                  duration="500"
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Discover
                  <DropDownContent>
                    {" "}
                    <SubA
                      to="discover"
                      smooth={true}
                      duration="500"
                      spy={true}
                      exact="true"
                      offset={-80}
                    >
                      Full Stack MERN Blog
                    </SubA>
                    <SubA
                      to="zephyris"
                      smooth={true}
                      duration="500"
                      spy={true}
                      exact="true"
                      offset={-80}
                    >
                      Zephyris: Chat and Collab
                    </SubA>
                    <SubA
                      to="meraki"
                      smooth={true}
                      duration="500"
                      spy={true}
                      exact="true"
                      offset={-80}
                    >
                      Meraki Gallery: E-Commerce
                    </SubA>
                    <SubA
                      to="crypto"
                      smooth={true}
                      duration="500"
                      spy={true}
                      exact="true"
                      offset={-80}
                    >
                      Crypto Currency Tracker
                    </SubA>
                    <SubA
                      to="music"
                      smooth={true}
                      duration="500"
                      spy={true}
                      exact="true"
                      offset={-80}
                    >
                      Zephyris Music Player
                    </SubA>
                    <SubA
                      to="collart"
                      smooth={true}
                      duration="500"
                      spy={true}
                      exact="true"
                      offset={-80}
                    >
                      House of Collart
                    </SubA>
                  </DropDownContent>
                </DropDownLink>
              </NavItem>
              <NavItem>
                <NavLinks
                  to="testimonials"
                  smooth={true}
                  duration="500"
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Testimonials
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to="contact"
                  smooth={true}
                  duration="500"
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Contact
                </NavLinks>
              </NavItem>
            </NavMenu>
            <NavBtn>
              <NavBtnLink
                to="contact"
                smooth={true}
                duration="500"
                spy={true}
                exact="true"
                offset={-80}
              >
                Get Started
              </NavBtnLink>
            </NavBtn>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
